import * as React from "react";
import {
  Paper,
  CssBaseline,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/CheckCircleOutline";
import { UserContext } from "../context/UserContext";
import { Api } from "../api";
import { hasError } from "../helpers/ResponseHelper";
import { useSnackbar } from "notistack";

export default function VerifyEmail() {
  const classes = useStyles();
  const userContext = React.useContext(UserContext);
  const { enqueueSnackbar } = useSnackbar();

  function sendVerificationEmail() {
    Api.employees
      .sendVerificationEmail(userContext.attributes.employeeId)
      .then((res) => {
        if (!hasError(res)) {
          enqueueSnackbar(
            "Success! Please check your inbox for a confirmation email.",
            { variant: "success" }
          );
        }
      });
  }

  return (
    <Paper className={classes.paper}>
      <CssBaseline />
      <CheckIcon className={classes.icon} />
      <Typography component="h1" variant="h5" className={classes.title}>
        Verify Your Account
      </Typography>
      <div className={classes.text}>
        Please check your inbox for a confirmation email. <br />
        Click the link in that email to confirm your email address.
      </div>
      <Button
        color="primary"
        className={classes.link}
        onClick={sendVerificationEmail}
      >
        Didn’t receive the email? Send it again.
      </Button>
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
  icon: {
    width: 50,
    height: 50,
    color: theme.palette.primary.main,
  },
  text: {
    textAlign: "center",
    lineHeight: "24px",
    color: "#222223",
  },
  link: {
    color: theme.palette.primary.main,
    textTransform: "none",
    fontSize: 14,
    fontWeight: 500,
    marginTop: 30,
  },
  main: {
    width: "auto",
    display: "block",
    marginLeft: 15,
    marginRight: 15,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 34,
    paddingTop: 80,
    paddingBottom: 80,
    flexGrow: 1,
    borderRadius: 20,
  },
  avatar: {
    width: 30,
    height: 40,
    display: "flex",
    position: "relative",
    overflow: "hidden",
    fontSize: "1.25rem",
    alignItems: "center",
    flexShrink: 0,
    userSelect: "none",
    borderRadius: "50%",
    justifyContent: "center",
    backgroundColor: theme.palette.secondary.main,
  },
  button: {
    marginTop: 30,
  },
  title: {
    marginTop: 15,
    marginBottom: 24,
    fontSize: 34,
    fontWeight: 600,
  },
  error: {
    background: "#B00020",
    color: "white",
    padding: 15,
    width: "100%",
    textAlign: "center",
  },
}));
